import React from 'react';

import { Text } from '@components/common';
import { CopyURLButton } from '@components/shared/CopyURLButton';
import { LinkSVG } from 'components/svgs';

type Props = {
  label?: string;
  helperText?: string;
  text: string;
};

export const TextWithCopyButton = ({ label, helperText, text }: Props) => {
  return (
    <div>
      <Text bold mb='2'>
        {label}
      </Text>
      <Text mb='2' h='400' color='gray-500'>
        {helperText}
      </Text>
      <div className='flex items-center space-x-2 rounded-md border border-gray-200 bg-gray-100 px-4 py-2.5'>
        <Text truncate className='flex-1' h='400'>
          {text}
        </Text>
        <CopyURLButton
          as='button'
          className='flex items-center justify-center rounded-full hover:bg-gray-200 hover:text-indigo-600'
          icon='link'
          text={text}
        >
          <LinkSVG />
        </CopyURLButton>
      </div>
    </div>
  );
};
